import RecruitmentAddPage from 'pages/Recruitment/RecruitmentAddPage';
import RecruitmentPage from 'pages/Recruitment/RecruitmentPage';

const recruitmentRoute = [
  {
    path: '/recruitment',
    exact: true,
    name: 'Danh sách tuyển dụng',
    function: 'CMS_RECRUITMENT_VIEW',
    component: RecruitmentPage,
  },
  {
    path: '/recruitment/add',
    exact: true,
    name: 'Thêm mới tuyển dụng',
    function: 'CMS_RECRUITMENT_ADD',
    component: RecruitmentAddPage,
  },
  {
    path: '/recruitment/edit/:recruitment_id',
    exact: true,
    name: 'Chỉnh sửa tuyển dụng',
    function: 'CMS_RECRUITMENT_EDIT',
    component: RecruitmentAddPage,
  },
  {
    path: '/recruitment/detail/:recruitment_id',
    exact: true,
    name: 'Chi tiết tuyển dụng',
    function: 'CMS_RECRUITMENT_VIEW',
    component: RecruitmentAddPage,
  },
];

export default recruitmentRoute;
